import { TypographyH3, TypographyP2 } from '@heidi/design-system/typography';
import { cn } from '@heidi/utils';
import { FormattedMessage } from 'react-intl';

import { tourStepsMessages } from '../../tour/tour-steps.messages';

/**
 * The Evidence tab before a question is asked. The guided-tour evidence screen
 * opens the tab on arrival, so the card needs the same waiting state Ask Heidi
 * shows for a fresh chat.
 *
 * Visibility is a CSS concern (not a mount) so the tab keeps its place in the
 * card while the rest of the preview's tabs stay mounted.
 */
export function EvidenceEmptyChat({ visible }: { visible: boolean }) {
  return (
    <div className={cn('flex flex-col gap-1.5 px-5 py-4', !visible && 'hidden')}>
      <TypographyH3 className="text-text-primary">
        <FormattedMessage {...tourStepsMessages.evidenceEmptyTitle} />
      </TypographyH3>
      <div className="flex items-center gap-2">
        <span className="size-2 shrink-0 rounded-full bg-accent-sunlight-hover" />
        <TypographyP2 className="text-text-secondary">
          <FormattedMessage {...tourStepsMessages.evidenceEmptyBody} />
        </TypographyP2>
      </div>
    </div>
  );
}
